var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topdiv"},[_c('div',{attrs:{"id":"bars"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"centerBox"},[_c('div',{staticClass:"topMenu"},[_c('logo'),_c('search'),_c('TopMenuItem')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }